import React from 'react';
import { Container, Row } from 'reactstrap';
import AccountStatusAll from './components/AccountStatusAll';
import PageHeader from '../../../../shared/components/PageHeader';

export default function AccountStatusAllPage() {
  return (
    <Container>
      <Row>
        <PageHeader title="Platform &amp; Account API Status" subhead="Live API status checks across all platforms and accounts." />
      </Row>
      <AccountStatusAll />
    </Container>
  );
}

